<template>
  <img src="@/assets/imgs/picture/sshsdbfmfmbmfn.png" alt="">
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped lang="scss">
img{
  width: 100%;
}
</style>
